import { useSaveUserProfile } from '@actions';
import ToggleButton from '@components/V4/ToggleButton';
import useToast from 'apps/agora/src/hooks/useToast';
import { BasicProps } from 'apps/agora/src/utils/types';
import { useState } from 'react';
import { useQueryClient } from 'react-query';
import SessionModalFormWrapper from '../../../DetailsModalFormWrapper';

interface SettingsFormProps extends BasicProps {
  userId: string;
  isEducationStrategist: boolean;
  onCloseEditForm: () => void;
}

const SettingsForm = (props: SettingsFormProps) => {
  const { userId, isEducationStrategist: initialValue, onCloseEditForm } = props;

  const toast = useToast();
  const query = useQueryClient();

  const [isEducationStrategist, setIsEducationStrategist] = useState<boolean>(initialValue);

  const { mutate: saveProfile, isLoading } = useSaveUserProfile(userId || '', {
    onSuccess: async () => {
      toast.success("Successfully updated mentor's profile.");
      await query.invalidateQueries('/users/:id/profile');
      onCloseEditForm();
    },
    onError: () => {
      toast.error('Profile could not be saved.');
    },
  });

  const submitHandler = () => {
    saveProfile({ isEducationStrategist });
  };

  return (
    <SessionModalFormWrapper
      title="Edit Settings"
      onCancel={onCloseEditForm}
      isLoading={isLoading}
      submitHandler={submitHandler}
    >
      <div className="flex items-center justify-between">
        <span className="font-raleway text-sm text-white">Education Strategist</span>
        <ToggleButton
          isChecked={isEducationStrategist}
          onClick={() => setIsEducationStrategist((value) => !value)}
        />
      </div>
    </SessionModalFormWrapper>
  );
};

export default SettingsForm;
